@if (!isLoading && addressForm) {
  <div class="address-form-container">
    <h2>{{ 'address_form_title' | locale }}</h2>
    <p class="info-message">{{ patient?.name }} {{ 'address_form_info_message' | locale }}</p>
    <form [formGroup]="addressForm">
      <app-autocomplete
        label="address_form_country"
        [form]="addressForm"
        controlName="country"
        placeholder="address_form_select_country"
        [items]="filteredCountries"
        [displayFn]="displayCountryFn">
      </app-autocomplete>
      <app-autocomplete label="address_form_address" [form]="addressForm" controlName="address"
        placeholder="address_form_address_placeholder" [items]="filteredAddresses" [displayFn]="displayAddressFn"
        (optionSelectedEvent)="onAddressSelected($event)">
      </app-autocomplete>
      @if (showZipCode) {
        <mat-label [isRequired]="zipCode">{{ 'address_form_zip_code' | locale }}</mat-label>
        <mat-form-field>
          <input
            matInput
            type="text"
            formControlName="zipCode"
            autocomplete="off"
            />
          <mat-error>{{ zipCode | errorMessage }}</mat-error>
        </mat-form-field>
      }
      <button
        type="button"
        mat-flat-button
        color="accent"
        (click)="getCurrentLocation()">
        {{ 'address_form_get_location' | locale }}
      </button>
      @if (showMap) {
        <div class="map-container">
          <app-map
            [coordinates]="coordinates"
            (locationSelected)="onLocationSelected($event)">
          </app-map>
        </div>
      }
      <div class="form-actions">
        <button
          type="button"
          (click)="onSubmit()"
          mat-flat-button
          color="primary"
          [disabled]="!coordinates || !addressForm.valid">
          {{ 'address_form_save' | locale }}
          <mat-icon svgIcon="arrow-right" class="east"></mat-icon>
        </button>
      </div>
    </form>
  </div>
}
